import { SearchAdResult } from "../searchAdResult.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class SearchTemplatesSerializer extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new SearchAdResult();
        this._copyAttributes(gp, data);
        return gp;

    }

}
